import * as React from "react";

import { Box, Link, makeStyles, Theme } from "@material-ui/core";

import { ProgressStepper } from "client/components";
import { useBranding, useTranslation } from "client/hooks";
import { logAmplitudeEvent } from "client/lib/amplitude";
import { routes } from "client/utils";

const useStyles = makeStyles((theme: Theme) => ({
  logout: {
    color: theme.palette.common.black,
  },
}));

interface IProps {
  includeProgressBar?: boolean;
  showActionBar?: boolean;
}

const ActionBar: React.FC<Partial<IProps>> = () => {
  const classes = useStyles();
  const t = useTranslation();
  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center">
      <Link
        className={classes.logout}
        href={routes.logout + window.location.search}
        onClick={() => {
          logAmplitudeEvent("REDESIGN_SIGN_UP", "logout_link_clicked");
        }}
      >
        <strong>{t("uiLogout")}</strong>
      </Link>
    </Box>
  );
};

export const Header: React.FC<IProps> = ({
  showActionBar = false,
  includeProgressBar = false,
}) => {
  const { Logo, brandTitle } = useBranding();
  return (
    <Box px={{ xs: 2, md: 0 }} pb={2} pt={3}>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex">
          <Box>
            <Logo alt={`${brandTitle} logo`} />
          </Box>
        </Box>
        {showActionBar && <ActionBar />}
      </Box>
      {includeProgressBar && <ProgressStepper />}
    </Box>
  );
};
